import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListFormulaCardsResponse, ListFormulaCardsQueryVariables } from '../types';

const listFormulaCardsQuery = gql`
  query OvertimeListFormulaCards($status: String) {
    overtimeListFormulaCards(status: $status) {
      code
      success
      message
      data {
        otFormulaCards {
          id
          name
          rateType
          rateUnit
          flatRate
          multiplier
          dailyAllowance
          formulaTemplate
          status
          createdAt
          updatedAt
          createdBy
        }
        total
      }
    }
  }
`;

const listFormulaCards = (queryVariables?: ListFormulaCardsQueryVariables) => {
  return graphQLApi<ListFormulaCardsResponse, ListFormulaCardsQueryVariables>({
    query: listFormulaCardsQuery,
    queryVariables: queryVariables ?? {},
  });
};

export default listFormulaCards;
